module.exports = __webpack_public_path__ + "static/media/remove.2fa0aa18.svg";